// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__Ma-0s","title":"Contact_title__evB1T","intro-gradient":"Contact_intro-gradient__EkrdK"};